import {Component, ComponentFactoryResolver, Inject, OnInit, Type, ViewChild, ViewContainerRef} from '@angular/core';
import {Observable} from 'rxjs';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {ModalService} from '../../state/modal.service';
import {ModalQuery} from '../../state/modal.query';
import {Modal} from '../../state/modal.model';
import {Production} from '../../modal.tokens';

const TRANSITION_DURATION = 150;

@Component({
  selector: 'ext-modal-outlet',
  templateUrl: './modal-outlet.component.html',
  styleUrls: ['./modal-outlet.component.scss'],
  animations: [
    trigger('listAnimation', [
      state('true', style({opacity: 1.0})),
      state('void', style({opacity: 0.0})),
      transition('* => void', [ // each time the binding value changes
        animate(TRANSITION_DURATION)
      ]),
    ])
  ]
})

export class ModalOutletComponent implements OnInit {

  test: boolean = false;

  @ViewChild('container', {read: ViewContainerRef, static: true}) container: ViewContainerRef;

  modals$: Observable<Modal[]>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              // private modalService: ModalService,
              @Inject(Production) public PRODUCTION: boolean,
              private modalQuery: ModalQuery) {}

  ngOnInit() {
    this.modals$ = this.modalQuery.selectAll();
  }

  getModalId(modal: Modal) {
    return modal.id;
  }

  dismiss(modal: Modal) {
  //   this.modalService.hide(modal.id);
  }
}
